import script from "./UnlockBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./UnlockBanner.vue?vue&type=script&setup=true&lang=js"

import "./UnlockBanner.vue?vue&type=style&index=0&id=4173fe72&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4173fe72"]])

export default __exports__